import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core" ;
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_category_basic_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: csswidth, height: cssheight}"></div>`;
    }

    public getTemplateName(): string{
        return "amCharts_v4_category_basic_template";
    }

    protected buildViewModel(): any{

        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            category: ko.observable(""),
            csswidth: ko.observable("98%"),
            cssheight: ko.observable("550px"),
            clickableLegend: ko.observable(1),
            cursorEnabled: ko.observable(1),
            xScrollbarEnabled: ko.observable(1),
            truncateLabels: ko.observable(0),
            autoRotateLabels: ko.observable(1),
            labelMaxWidth: ko.observable(100),
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    public setCategory(category) {
        this.getTemplateViewModel().category(category);
    }

    public setCssHeight(cssheight){

        this.getTemplateViewModel().cssheight(cssheight);
    }

    public setClickableLegend(value){

        this.getTemplateViewModel().clickableLegend(value);
    }

    public setCursorEnabled(value){

        this.getTemplateViewModel().cursorEnabled(value);
    }

    public setXScrollbarEnabled(value){

        this.getTemplateViewModel().xScrollbarEnabled(value);
    }

    public setLabelMaxWidth(value){

        this.getTemplateViewModel().labelMaxWidth(value);
    }

    public setTruncateLabels(value){

        this.getTemplateViewModel().truncateLabels(value);
    }

    public setAutoRotateLabels(value){

        this.getTemplateViewModel().autoRotateLabels(value);
    }

    public applyValueAxisFormatting(yAxis) {

        yAxis.renderer.line.strokeOpacity = 1;
        yAxis.renderer.line.strokeWidth = 2;
        yAxis.renderer.line.stroke = am4core.color('#1886ff');
        yAxis.renderer.labels.template.fill = am4core.color('#1886ff');
    }

    public setupChart(chartData){

        let _this = this;

        /* Chart code */
        am4core.options.autoDispose = true;
        am4core.useTheme(am4themes_animated);

        // Create chart instance
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        // Add data
        chart.data = chartData;

        // Create axes
        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());

        xAxis.dataFields.category = this.getTemplateViewModel().category();

        var label = xAxis.renderer.labels.template;
        if (this.getTemplateViewModel().labelMaxWidth() != null){

            label.maxWidth = this.getTemplateViewModel().labelMaxWidth();
        }
        if (this.getTemplateViewModel().truncateLabels() == 1) {
            label.truncate = true;
        }

        if (this.getTemplateViewModel().autoRotateLabels() == 1){

            //Auto rotate x-axis values columns become too narrow
            xAxis.events.on("sizechanged", function (ev){

                var axis = ev.target;
                var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                if (cellWidth < axis.renderer.labels.template.maxWidth){
                    axis.renderer.labels.template.rotation = -45;
                    axis.renderer.labels.template.horizontalCenter = "right";
                    axis.renderer.labels.template.verticalCenter = "middle";
                } else {
                    axis.renderer.labels.template.rotation = 0;
                    axis.renderer.labels.template.horizontalCenter = "middle";
                    axis.renderer.labels.template.verticalCenter = "top";
                }
            });
        }

        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 1;

        // Add legend
        chart.legend = new am4charts.Legend();

        if (this.getTemplateViewModel().clickableLegend() == 0){

            //Disable clicking on Legend
            chart.legend.itemContainers.template.clickable = false;
            chart.legend.itemContainers.template.focusable = false;
            chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
        }

        if (this.getTemplateViewModel().xScrollbarEnabled() == 1){

            //Enable XYChartScrollbar
            chart.scrollbarX = new am4charts.XYChartScrollbar();
        }

        if (chartData.length === 0 ){

            // Give no data message if data is empty
            let message = chart.createChild(am4core.Label);
            message.text = "No data available.";
            message.fontSize = 15;
            message.align = "center";
            message.isMeasured = false;

            message.x = am4core.percent(50);
            message.y = am4core.percent(50);
            message.verticalCenter = "middle";
            message.horizontalCenter = "middle";
        }

        if (this.getTemplateViewModel().cursorEnabled() == 1) {
            // Add cursor
            chart.cursor = new am4charts.XYCursor();
        }

        return chart;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_category_basic_template.ts